export type AutofakeFlowModule = typeof import('./showAutofakeModal');

/**
 * The one dynamic import of the Autofake modal chunk, isolated in its own module
 * because native import() throws under jest — tests jest.mock this file and hand
 * back jest.requireActual, the same seam single_work/loswp/lazyMoreActionsMenu.ts
 * uses. Production always takes the webpack chunk split this import creates.
 */
export function loadAutofakeFlow(): Promise<AutofakeFlowModule> {
  return import('./showAutofakeModal');
}
